import { motion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];

export const FadeIn = ({ children, delay = 0, y = 32, className = '', as = 'div' }) => {
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-70px' }}
      transition={{ duration: 0.75, delay, ease: EASE }}
      className={className}
    >
      {children}
    </Comp>
  );
};

export const MaskedLine = ({ children, delay = 0, className = '' }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: '112%' }}
      animate={{ y: 0 }}
      transition={{ duration: 0.95, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const ChapterHeading = ({ number, eyebrow, title, copy, dark = true, align = 'left' }) => (
  <FadeIn className={`max-w-3xl ${align === 'center' ? 'mx-auto text-center' : ''}`}>
    <p
      data-testid={`chapter-eyebrow-${number}`}
      className={`font-heading text-xs md:text-sm font-bold tracking-[0.3em] uppercase mb-5 ${
        dark ? 'text-krug-tealbright' : 'text-krug-teal'
      }`}
    >
      <span className="text-krug-gold mr-3">{number}</span>
      {eyebrow}
    </p>
    <h2 className={`font-heading font-800 font-extrabold tracking-tight text-3xl md:text-4xl lg:text-5xl leading-[1.05] ${
      dark ? 'text-white' : 'text-krug-navy'
    }`}>
      {title}
    </h2>
    {copy && (
      <p className={`mt-6 text-base md:text-lg leading-relaxed ${dark ? 'text-slate-400' : 'text-slate-600'}`}>
        {copy}
      </p>
    )}
  </FadeIn>
);
